export const PERMISSION_GROUP_TYPES = Object.freeze({
    USERS: {
        en: "User Permissions",
        tr: "Kullanıcı İzinleri",
        ru: " Разрешения пользователя ",
    },
    VISITOR: {
        en: "Visitor Permissions",
        tr: "Ziyaretci İzinleri",
        ru: " Разрешения для посетителей ",
    },
    BANNED_WORD: {
        en: "Banned Word Permissions",
        tr: "Yasaklı Kelime İzinleri",
        ru: " Управление заблокироваными словами ",
    },
    CHAT: {
        en: "Chat Permissions",
        tr: "Konuşma İzinleri",
        ru: " Разрешения чата ",
    },
    ROLE: {
        en: "Role Permissions",
        tr: "Rol İzinleri",
        ru: " Разрешения на должность",
    },
    TOPIC: {
        en: "Subject Permissions",
        tr: "Konu İzinleri",
        ru: " Субъектные разрешения ",
    },
    CONTENT: {
        en: "Prepared Content Permissions",
        tr: "Hazır İçerik İzinleri",
        ru: " Готовые разрешения на контент ",
    },
    WELCOME: {
        en: "Welcome Message Permissions",
        tr: "Karşılama Mesajı İzinleri",
        ru: " Разрешения на приветственное сообщение ",
    },
    SETTING: {
        en: "Setting Permissions",
        tr: "Ayar İzinleri",
        ru: " Установка разрешений ",
    },
    REPORT: {
        en: "Report Permissions",
        tr: "Rapor İzinleri",
        ru: " Разрешения на отчет ",
    },
    OSR: {
        en: "Offline Support Permission",
        tr: "Çevrimdışı Destek İzinler",
        ru: " Разрешение на автономную поддержку ",
    },
    CATALOG: {
        en: "Catalog",
        tr: "Katalog",
        ru: " Каталог ",
    },
});

const cretePermission = (group, descTr, descEn, descRu) => ({
    en: {
        entity: group.en,
        description: descEn,
    },
    tr: {
        entity: group.tr,
        description: descTr,
    },
    ru: {
        entity: group.ru,
        description: descRu,
    },
});
export const PERMISSION_TYPES = Object.freeze({
    "user.create": cretePermission(
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Ekleme",
        "Add User",
        "Добавление пользователя"
    ),
    "user.get": cretePermission(
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Görüntüleme",
        "View User",
        "Просмотр пользователя"
    ),
    "user.update": cretePermission(
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Güncelleme",
        "Update User",
        "Обновление пользователя"
    ),
    "user.delete": cretePermission(
        PERMISSION_GROUP_TYPES.USERS,
        "Kullanıcı Silme",
        "Delete User",
        "Удаление пользователя"
    ),

    "visitor.block": cretePermission(
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Engelleme",
        "Blocking Visitor",
        "Блокировка посетителей"
    ),
    "visitor.unblock": cretePermission(
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Engel Kaldırma",
        "Unblocking Visitor",
        "Разблокировать посетителя"
    ),
    "visitor.view": cretePermission(
        PERMISSION_GROUP_TYPES.VISITOR,
        "Ziyaretçi Detay Görüntüleme",
        "View Visitor List",
        "Отображение сведений о посетителях"
    ),
    "bannedVisitor.view": cretePermission(
        PERMISSION_GROUP_TYPES.VISITOR,
        "Yasaklı Ziyaretçiler Görüntüleme",
        "View Banned Visitor",
        "Просмотр запрещенных посетителей"
    ),

    "bannedWord.create": cretePermission(
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Ekleme",
        "Add Banned Word",
        "Добавление запрещенных слов"
    ),
    "bannedWord.get": cretePermission(
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Görüntüleme",
        "View Banned Word",
        "Отображение запрещенных слов"
    ),
    "bannedWord.update": cretePermission(
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Güncelleme",
        "Update Banned Word",
        "Обновление запрещённых слов"
    ),
    "bannedWord.delete": cretePermission(
        PERMISSION_GROUP_TYPES.BANNED_WORD,
        "Yasaklı Kelime Silme",
        "Delete Banned Word",
        "Удалить запрещённое слово"
    ),

    "chat.get": cretePermission(PERMISSION_GROUP_TYPES.CHAT, "Konuşma Görüntüleme", "View Chat", "Просмотр чата"),
    "chat.update": cretePermission(
        PERMISSION_GROUP_TYPES.CHAT,
        "Konuşma Güncelleme",
        "Update Chat",
        " Обновление чата"
    ),
    "archives.get": cretePermission(PERMISSION_GROUP_TYPES.CHAT, "Arşiv Listeleme", "View Archive", " Просмотр архива"),
    "role.create": cretePermission(PERMISSION_GROUP_TYPES.ROLE, "Rol Ekleme", "Add Role", " Добавление должности"),
    "role.get": cretePermission(PERMISSION_GROUP_TYPES.ROLE, "Rol Görüntüleme", "View Role", " Просмотр должности"),
    "role.update": cretePermission(
        PERMISSION_GROUP_TYPES.ROLE,
        "Rol Güncelleme",
        "Update Role",
        " Обновление должности"
    ),
    "role.delete": cretePermission(PERMISSION_GROUP_TYPES.ROLE, "Rol Silme", "Delete Role", " Удаление должности"),
    "topic.create": cretePermission(PERMISSION_GROUP_TYPES.TOPIC, "Konu Ekleme", "Add Subject", " Добавление темы"),
    "topic.get": cretePermission(PERMISSION_GROUP_TYPES.TOPIC, "Konu Görüntüleme", "View Subject", " Просмотр темы"),
    "topic.update": cretePermission(
        PERMISSION_GROUP_TYPES.TOPIC,
        "Konu Güncelleme",
        "Update Subject",
        " Обновить тему"
    ),
    "topic.delete": cretePermission(PERMISSION_GROUP_TYPES.TOPIC, "Konu Silme", "Delete Subject", " Удалить тему"),
    "prepared.create": cretePermission(
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Ekleme",
        "Add Prepared Content",
        " Добавить готовый контент"
    ),
    "prepared.get": cretePermission(
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Görüntüleme",
        "View Prepared Content",
        " Посмотреть готовый контент"
    ),
    "prepared.update": cretePermission(
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Güncelleme",
        "Update Prepared Content",
        " Обновить подготовленный контент"
    ),
    "prepared.delete": cretePermission(
        PERMISSION_GROUP_TYPES.CONTENT,
        "Hazır İçerik Silme",
        "Delete Prepared Content",
        " Удалить подготовленный контент"
    ),
    "welcome.create": cretePermission(
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Ekleme",
        "Add Welcome Message",
        " Добавление приветственного сообщения"
    ),
    "welcome.get": cretePermission(
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Görüntüleme",
        "View Welcome Message",
        " Просмотр приветственного сообщения"
    ),
    "welcome.update": cretePermission(
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Güncelleme",
        "Update Welcome Message",
        " Обновление приветственного сообщения"
    ),
    "welcome.delete": cretePermission(
        PERMISSION_GROUP_TYPES.WELCOME,
        "Karşılama Mesajı Silme",
        "Delete Welcome Message",
        " Удаление приветственного сообщения"
    ),
    "setting.create": cretePermission(
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Ekleme",
        "Add Setting",
        " Добавление настроек"
    ),
    "setting.get": cretePermission(
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Görüntüleme",
        "View Setting",
        " Просмотр настроек"
    ),
    "setting.update": cretePermission(
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Güncelleme",
        "Update Setting",
        " Обновить настройки"
    ),
    "setting.delete": cretePermission(
        PERMISSION_GROUP_TYPES.SETTING,
        "Ayar Silme",
        "Delete Setting",
        " Удалить настройку"
    ),
    "report.create": cretePermission(PERMISSION_GROUP_TYPES.REPORT, "Rapor Ekleme", "Add Report", " Добавить отчет"),
    "report.get": cretePermission(
        PERMISSION_GROUP_TYPES.REPORT,
        "Rapor Görüntüleme",
        "View Report",
        " Посмотреть отчет"
    ),
    "report.update": cretePermission(
        PERMISSION_GROUP_TYPES.REPORT,
        "Rapor Güncelleme",
        "Update Report",
        " Обновить отчет"
    ),
    "report.delete": cretePermission(
        PERMISSION_GROUP_TYPES.REPORT,
        "Rapor Silme",
        "Delete Report",
        " Удалить отчет"),
    "offlineSupportRequest.get": cretePermission(
        PERMISSION_GROUP_TYPES.OSR,
        "Mesajları Listeleme",
        "List Messages",
        " Список сообщений"
    ),
    "offlineSupportRequest.update": cretePermission(
        PERMISSION_GROUP_TYPES.OSR,
        "Cevap Yazma",
        "Write Response",
        "Написать Ответ"
    ),
    "offlineSupportRequest.delete": cretePermission(
        PERMISSION_GROUP_TYPES.OSR,
        "Mesaj Silme",
        "Delete Message",
        " Удалить сообщение"
    ),
    "offlineSupportRequest.create": cretePermission(
        PERMISSION_GROUP_TYPES.OSR,
        "Çevrimdışı Destek Talebi Oluşturma İzni",
        "Creating Offline Support Request Permission ",
        "Создание разрешения на запрос поддержки в автономном режиме"
    ),
    "catalog.get": cretePermission(
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Görüntülüme İzni",
        "View Catalog",
        " Просмотр каталога"
    ),
    "catalog.update": cretePermission(
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Güncelleme İzni",
        "Update Catalog",
        " Обновление каталога"
    ),
    "catalog.create": cretePermission(
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Oluşturma İzni",
        "Add Catalog",
        "Добавить каталог"
    ),
    "catalog.delete": cretePermission(
        PERMISSION_GROUP_TYPES.CATALOG,
        "Catalog Silme İzni",
        "Delete Catalog",
        " Удалить каталог"
    ),
});
